export const isRequired = (field, form) => {
    if (field.required) {
        return true;
    }

    return (field.conditionalRequiredFieldName &&
        field.conditionalRequiredFieldValues.includes(
            form[field.conditionalRequiredFieldName]
        )
    )
}
